module.exports = __webpack_public_path__ + "static/media/security-camera-inactive.07d2fac1.svg";